const nb = {
  meta: { title: "Trollfossjakten · Jakt 84 troll mellom Lavangen og Årstein" },
  sound: { mute: "Slå av trollyder", unmute: "Slå på trollyder" },
  nav: { map: "Kart", trolls: "Troll", seasons: "Årstider", pricing: "Priser", faq: "Spørsmål", getApp: "Last ned appen", hosts: "Bli vert" },
  tagline: "61 troll gratis for alltid. Resten gjemmer seg — ta med et pass.",
  store: { soon: "Appen er nesten ute av skogen", soonBody: "Lenkene til butikkene åpner ved lansering — kom tilbake snart.", appStore: "App Store", playStore: "Google Play", download: "Last ned fra", getIt: "Hent den på" },
  hero: {
    kicker: "Lavangen · Gratangen · Troms",
    title: "Jakt 84 troll mellom Lavangen og Årstein.",
    pitch: "9 fosser, 84 håndlagde troll og én fjordvei. Gratis å starte — funker på ski om vinteren og på rulleskøyter om sommeren.",
    cta: "Åpne jakten",
    ctaMap: "Se hele kartet",
    stats: [["84", "troll"], ["9", "fosser"], ["61", "gratis for alltid"], ["4", "årstider"]],
    stamp: "Gratis å starte",
    photoNote: "Fosser · fjorder · troll",
  },
  what: {
    kicker: "Hva er Trollfossjakten?",
    title: "En skattejakt i folkeeventyr langs en ekte fjordvei.",
    cols: [
      { title: "Gå løypa", body: "Følg veien fra Lavangen til Årstein til fots, på sykkel, ski eller rulleskøyter. Ni fosser viser vei." },
      { title: "Fang troll", body: "84 håndlagde troll gjemmer seg ved bekkene, i fjæra og ved butikkene. Finn dem, fang dem, fyll dagboka." },
      { title: "Tjen Trollkroner", body: "Samle appens egen valuta og bruk den hos partnerhytter, kafeer og butikker langs ruta." },
    ],
    callout: "Ingen registrering nødvendig. Åpne appen, start jakten.",
  },
  map: {
    kicker: "Løypekartet",
    title: "Hvert troll, merket av.",
    body: "84 troll spredt langs veien fra Lavangen til Årstein, via Røkenes, Hestnes og Sørsida. Trykk på en nål for å møte et — og fang det på ekte i appen.",
    chips: { all: "Alle", common: "Vanlig", rare: "Sjelden", epic: "Episk", legendary: "Legendarisk", festivals: "Festivaler", merchants: "Kjøpmenn" },
    showing: "troll vises",
    start: "Lavangen · start",
    finish: "Årstein · mål",
    waterfall: "Foss",
    catchIt: "Fang det i appen",
    close: "Lukk",
    recenter: "Sentrer",
  },
  xp: {
    kicker: "XP og spillsystem",
    title: "Jakt, gå opp i nivå, skryt litt.",
    body: "Hver fangst gir XP. Sjeldnere troll gir mer — og noen dukker bare opp når kalenderen sier det.",
    cards: {
      xp: { title: "XP per sjeldenhet", body: "Jo bedre de gjemmer seg, desto mer betaler de." },
      ach: { title: "12 prestasjoner", body: "Opptil 5 000 XP hver. Noen å begynne med:", more: "+ 6 til å oppdage i appen" },
      items: { title: "Gjenstander og sett", body: "Samle småting trollene legger igjen og fullfør sett.", list: ["Perler", "Runer", "Vafler", "Piratgull"] },
      kroner: { title: "Trollkroner", body: "Tjenes gjennom vervinger, daglig spinn og kjøpmannstroll. Brukes hos partnerhytter og kjøpmenn." },
    },
    achievements: [["Første fangst", 20], ["Festivalfan", 500], ["Bekkekonge", 800], ["Ensom kriger", 1000], ["Legendejeger", 1500], ["Årstidsrunden", 5000]],
    extras: [
      { title: "Streak + streakskjold", body: "Jakt hver dag for å bygge streaken. Skjoldet redder én tapt dag per uke." },
      { title: "Daglig spinn", body: "Et vektet lykkehjul med 3 nivåer. Ett spinn hvert døgn." },
      { title: "Pass", body: "Episk pass eller Sjelden pass, gyldig i 365 dager fra aktivering. Nivåer for person, familie, lag og bussgruppe." },
      { title: "Spesialtroll", body: "2 helgetroll (fre–søn), 10 festivaltroll, 6 kjøpmannstroll hos lokale bedrifter og 5 kampanjetroll." },
    ],
  },
  gallery: {
    kicker: "Trolldagboka",
    title: "Møt alle 84.",
    body: "Hvert troll har et navn, et kallenavn og en uvane. Trykk på et kort for å lese dagboksnotatet.",
    chips: { all: "Alle", common: "Vanlig", rare: "Sjelden", epic: "Episk", legendary: "Legendarisk", festivals: "Festivaler", merchants: "Kjøpmenn", weekend: "Helg", promo: "Kampanje" },
    more: "Vis flere troll",
    count: "av 84",
    portraitNote: "Resten gjemmer seg — finn dem i appen.",
    hidden: "gjemmer seg fortsatt",
    hiding: "Gjemmer seg",
  },
  journal: {
    entry: "Dagboksnotat",
    where: "Hvor",
    waterfall: "Foss",
    xp: "XP",
    access: "Låses opp med",
    window: "Dukker opp",
    weekend: "Bare fredag til søndag",
    liveNow: "Ute nå",
    catchIt: "Fang det i appen",
  },
  access: { free: "Gratis for alltid", epic_pass: "Episk pass", rare_pass: "Sjelden pass" },
  rarity: { common: "Vanlig", rare: "Sjelden", epic: "Episk", legendary: "Legendarisk" },
  category: { stream: "Bekketroll", intro: "Introguide", merchant: "Kjøpmannstroll", promo: "Kampanjetroll", weekend: "Helgetroll", festival_sami: "Samisk festivaltroll", festival_norwegian: "Norsk festivaltroll" },
  specials: {
    kicker: "Spesialtroll",
    title: "19 spesialtroll — og 5 kampanjetroll på toppen.",
    body: "Noen troll har sin egen kalender. Festivaltroll dukker bare opp på de ekte festivaldatoene.",
    flavours: [
      { key: "intro", count: 1, title: "Introguide", body: "Ditt første troll i Lavangen — viser deg hvordan jakten fungerer." },
      { key: "festival_sami", count: 4, title: "Samiske festivaltroll", body: "Samefolkets dag, Riddu Riđđu og Márkomeannu." },
      { key: "festival_norwegian", count: 6, title: "Norske festivaltroll", body: "Fra 17. mai til mørketida." },
      { key: "weekend", count: 2, title: "Helgetroll", body: "Ute bare fredag til søndag." },
      { key: "merchant", count: 6, title: "Kjøpmannstroll", body: "Bor hos ekte lokale bedrifter langs ruta." },
      { key: "promo", count: 5, title: "Kampanjetroll", body: "Låses opp med vervinger, plakater og kampanjekoder." },
    ],
    calendar: "Festivalkalender",
    next: "Neste periode",
    liveNow: "Ute nå",
  },
  festivals: {
    "Sámi National Day": "Samefolkets dag", "Riddu Riđđu": "Riddu Riđđu", "Márkomeannu": "Márkomeannu",
    "Constitution Day": "Grunnlovsdagen 17. mai", "Midsummer": "Sankthans", "Lussinatta": "Lussinatta",
    "Christmas": "Jul", "Midnight Sun": "Midnattssol", "Polar Night": "Mørketid",
  },
  seasons: {
    kicker: "Fire årstider",
    title: "Én løype, fire helt ulike stemninger.",
    standout: "Årstidens troll",
    tabs: {
      winter: { name: "Vinter", title: "Ski under nordlyset", body: "Gli langs ruta på langrennsski mens nordlyset danser over fjorden. Hodelykt på, termosen full." },
      spring: { name: "Vår", title: "Reinsdyrpåske", body: "Lange, lyse dager, skare og rein på vandring. Perfekt for familier på de rolige strekkene." },
      summer: { name: "Sommer", title: "Bål i midnattssola", body: "Rulleskøyter på de glatte strekkene, ungene spurter foran på sykkel, og så tenner dere bål når sola nekter å gå ned." },
      autumn: { name: "Høst", title: "Soppturer", body: "Gylne bjørker, blåbær og kantareller. Besteforeldre elsker de rolige strekkene — det gjør trollene også." },
    },
  },
  merchants: {
    kicker: "Lokale bedrifter",
    title: "Kjøpmannstroll bor på ekte lokale steder.",
    body: "Seks troll bor hos hytter, kafeer, butikker og utleiere langs ruta. Fang dem gratis og bruk Trollkronene dine der.",
    partnerSoon: "Partner avsløres ved lansering",
    spend: "Bruk Trollkroner her",
    types: { "Cabin rental": "Hytteutleie", "Farm shop": "Gårdsbutikk", "Café": "Kafé", "Kayak rental": "Kajakkutleie", "Bakery": "Bakeri", "Grocer · finish line": "Dagligvare · mål" },
  },
  pricing: {
    kicker: "Priser",
    title: "Start gratis. Ta med et pass for resten.",
    launch: "Lanseringspris · 50 % rabatt ut sesongen 2026",
    tiers: { person: "Person", family: "Familie", team: "Lag", bus: "Bussgruppe" },
    days: "365 dager fra aktivering",
    free: { name: "Gratis", price: "0 kr", line: "61 troll gratis for alltid", body: "Ingen registrering nødvendig.", perks: ["Alle vanlige og sjeldne bekketroll", "Alle 6 kjøpmannstroll", "Introguiden + 5 kampanjetroll"], cta: "Start gratis" },
    epic: { name: "Episk pass", line: "Låser opp episke + legendariske troll", perks: ["Alle episke og legendariske bekketroll", "Begge helgetrollene"], cta: "Hent Episk pass" },
    rare: { name: "Sjelden pass", line: "Låser opp alle troll — festivaler og legendariske inkludert", perks: ["Alle 84 troll", "Alle 10 festivaltroll", "Alt i Episk pass"], cta: "Hent Sjelden pass", ribbon: "Alle 84 troll" },
    note: "Pass kjøpes i appen. Lanseringsprisen er tidsbegrenset.",
    was: "før",
  },
  faq: {
    kicker: "Spørsmål og svar",
    title: "Spørsmål fra startstreken.",
    items: [
      ["Må jeg registrere meg?", "Nei. Last ned appen, åpne den og begynn å jakte. 61 troll er gratis for alltid."],
      ["Er det mobildekning langs løypa?", "Dekningen langs veien er stort sett god, men den kan falle litt i dalene. Lad telefonen og noter nødnumrene før du drar."],
      ["Kan jeg bruke den om vinteren?", "Ja. Trollene er ute hele året. Ta med ski eller brodder, hodelykt til mørketida, og sjekk føret før du drar."],
      ["Passer det for barn?", "Ja. Mange troll står nær veien, og de rolige strekkene passer for små bein, sykler og barnevogner. Deler av ruta følger offentlig vei, så pass på trafikken."],
      ["Hvor parkerer jeg, og hvordan kommer jeg tilbake?", "Start i Lavangen eller i Årstein. Regionbusser går på deler av ruta — sjekk lokal rutetabell før du drar."],
      ["Hva er et kjøpmannstroll?", "Et troll som bor hos en ekte lokal bedrift langs ruta — en hytte, kafé eller butikk. Det er gratis å fange, og du kan bruke Trollkroner der."],
      ["Hva er Trollkroner?", "Appens egen valuta. Tjen den gjennom vervinger, daglig spinn og kjøpmannstroll, og bruk den hos partnerhytter og kjøpmenn."],
      ["Hvor nøyaktige er festivaldatoene?", "Festivaltroll dukker bare opp innenfor de ekte festivaldatoene. Flytter en festival datoene, flytter trollet seg også."],
      ["Hvor lenge varer et pass?", "Episk og Sjelden pass varer i 365 dager fra du aktiverer dem, med nivåer for person, familie, lag og bussgruppe."],
      ["Hva med personvernet mitt?", "Du kan spille uten konto. Appen bruker posisjonen din for å vise troll i nærheten mens du spiller. Denne nettsiden ber ikke om noe."],
    ],
  },
  install: { title: "Trollfossjakten", body: "61 troll gratis for alltid", cta: "Last ned", dismiss: "Skjul nedlastingslinjen" },
  footer: { supporter: "Bli støttespiller", about: "Om", press: "Presse", privacy: "Personvern", terms: "Vilkår", contact: "Kontakt", follow: "Følg jakten", soon: "Kommer ved lansering", country: "Norge", supportedBy: "Støttet av" },
  logoAlt: "Trollfossjakten-logo",
  langSwitch: "Språk",
  a11y: { menu: "Meny", footer: "Bunntekst", zoomIn: "Zoom inn", zoomOut: "Zoom ut", notifications: "Varsler" },
  sos: "Nødinfo",
  emergency: {
    back: "Tilbake",
    title: "Nødhjelp",
    alert: "Er du i fare, ring det lokale nødnummeret med en gang.",
    h1: "SOS — rask hjelp, hvor som helst langs løypa.",
    intro: "Trykk på et nummer for å ringe. Del posisjonen din, med bilde og melding om du vil, med familie, venner eller redningstjenesten.",
    step: "Steg {n}",
    country: "Ditt land",
    search: "Søk etter land…",
    noMatch: "Ingen land passer til",
    callNow: "Ring nå —",
    all: "Alle nødsituasjoner",
    police: "Politi",
    fire: "Brann",
    ambulance: "Ambulanse",
    locTitle: "Send posisjonen din",
    detect: "Finn posisjonen min",
    locating: "Finner posisjon…",
    refresh: "Oppdater posisjon",
    noGeo: "Nettleseren din støtter ikke posisjon.",
    locFail: "Fant ikke posisjonen din.",
    near: "I nærheten av",
    openMaps: "Åpne i Google Maps ↗",
    msgLabel: "Legg til en melding (valgfritt)",
    msgPh: "F.eks. Jeg har vrikket ankelen ved den andre fossen. Ta med vann og førstehjelpsskrin.",
    photoLabel: "Legg ved et bilde (valgfritt)",
    choose: "Velg bilde",
    change: "Bytt bilde",
    remove: "Fjern",
    previewAlt: "Vedlagt bilde",
    send: "Send nødposisjon",
    copy: "Kopier",
    shared: "Delt fra enheten din.",
    shareFail: "Kunne ikke åpne delemenyen. Prøv Kopier i stedet.",
    copied: "Kopiert.",
    copyFail: "Kopiering feilet.",
    privacy: "Deling bruker telefonens egen delemeny (SMS, WhatsApp, e-post osv.). Ingenting sendes via våre servere. Ved en ekte nødsituasjon: ring alltid nummeret over også.",
    backTrail: "Tilbake til løypa",
    msgHead: "🆘 NØDSITUASJON — jeg trenger hjelp.",
    mapLabel: "Kart",
    timeLabel: "Tid",
    shareTitle: "Nødhjelp — Trollfossjakten",
    notes: {
      NO: "112 er det europeiske nødnummeret. 110 går direkte til brann og 113 til medisinsk nødhjelp.",
      SE: "Ett nødnummer, 112, for alle tjenester.",
      FI: "112 når politi, brann og ambulanse.",
      DK: "112 ved nødsituasjoner, 114 for politi når det ikke haster.",
      IS: "Ett nummer i hele landet: 112.",
      DE: "110 for politi, 112 for brann og ambulanse.",
      FR: "17 politi, 18 brann, 15 ambulanse (SAMU). 112 fungerer også.",
      GB: "999 (eller 112) ved alle nødsituasjoner. 101 for politi når det ikke haster.",
      IE: "Både 112 og 999 fungerer.",
      NL: "112 ved nødsituasjoner, 0900-8844 for politi når det ikke haster.",
      ES: "112 dekker alt. Nasjonalt politi 091, lokalt politi 092.",
      IT: "112 ved alle nødsituasjoner, 113 statspolitiet.",
      PL: "112 når alle nødtjenester.",
      US: "Ring 911 ved alle nødsituasjoner. 311 for ikke-akutte saker i mange byer.",
      CA: "911 i hele landet ved alle nødsituasjoner.",
      AU: "Trippel null (000). 112 fungerer også fra mobil.",
      NZ: "111 i hele landet. 105 for politi når det ikke haster.",
      CN: "110 politi, 119 brann, 120 ambulanse. 122 ved trafikkulykker.",
      RU: "112 når alle tjenester. 102 politi, 101 brann, 103 ambulanse.",
      TH: "191 politi, 199 brann, 1669 ambulanse. Turistpolitiet 1155 (engelsktalende).",
    },
  },
};

export default nb;
